export const shouldSuppressApiErrorToast = (error) => {
  const status = error?.response?.status;
  return (
    status === 401 ||
    status === 419 ||
    error?.config?.__validationToastShown === true
  );
};

export const getApiErrorMessage = (error, fallback = "خطا در انجام عملیات") => {
  if (shouldSuppressApiErrorToast(error)) {
    return null;
  }

  const apiMessage = error?.response?.data?.message;
  if (apiMessage) {
    return apiMessage;
  }

  if (!error?.response) {
    if (error?.code === "ECONNABORTED") {
      return "زمان پاسخ‌دهی سرور طولانی شد. لطفاً چند ثانیه صبر کنید و دوباره تلاش کنید.";
    }
    return "خطا در اتصال به سرور. لطفاً اتصال اینترنت و XAMPP را بررسی کنید.";
  }

  return error?.message || fallback;
};

export const API_ERROR_TOAST_OPTIONS = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const showApiErrorToast = (
  toast,
  error,
  fallback = "خطا در انجام عملیات"
) => {
  const message = getApiErrorMessage(error, fallback);
  if (message) {
    toast.error(message, {
      ...API_ERROR_TOAST_OPTIONS,
      toastId: `api-error:${message}`,
    });
  }
};
